module.exports = __webpack_public_path__ + "media/images/mobile/home/type2-ad05ccb0530f259458590d3775085180.png";